import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export type CropData = { x: number; y: number; width: number; height: number };

/** MariaDB json() columns may return raw strings — parse safely. */
export function parseCropData(raw: unknown): CropData | null {
  if (!raw) return null;
  if (typeof raw === "string") {
    try {
      return JSON.parse(raw);
    } catch {
      return null;
    }
  }
  return raw as CropData;
}
